import React, { useMemo } from 'react';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import styles from './AuthTitleBlock.module.scss';

interface TitleBlockProps {
  title: string;
  description?: string;
  link?: {
    linkLabel: string;
    path;
  };
  button?: {
    buttonLabel: string;
    onClick: () => void;
  };
  classes?: {
    blockClass?: string;
    titleClass?: string;
    descriptionClass?: string;
    linkClass?: string;
  };
}

const AuthTitleBlock = ({ title, description = '', link, classes, button }: TitleBlockProps): JSX.Element => {
  const showDescription = description || (link?.path && link?.linkLabel) || button;

  const isLink = useMemo(() => Boolean(link?.path && link?.linkLabel), [link]);

  const displayedLink = useMemo(() => {
    if (link?.path && link?.linkLabel) {
      return (
        <React.Fragment>
          &nbsp;
          <Link to={link.path} className={cn(styles.link, { [classes?.linkClass]: classes?.linkClass })}>
            {link.linkLabel}
          </Link>{' '}
        </React.Fragment>
      );
    }

    return null;
  }, [classes?.linkClass, link]);

  const displayedButton = useMemo(() => {
    if (button?.onClick && button?.buttonLabel) {
      return (
        <React.Fragment>
          &nbsp;
          <button
            type="button"
            onClick={button.onClick}
            className={cn(styles.link, { [classes?.linkClass]: classes?.linkClass })}
          >
            {button.buttonLabel}
          </button>
        </React.Fragment>
      );
    }

    return null;
  }, [button, classes?.linkClass]);

  return (
    <div
      className={cn(styles.titleBlock, {
        [styles.extraMargin]: !showDescription,
        [classes?.blockClass]: classes?.blockClass
      })}
    >
      <h2
        className={cn(styles.title, {
          [styles.hideMargin]: !showDescription,
          [classes?.titleClass]: classes?.titleClass
        })}
      >
        {title}
      </h2>

      {showDescription && (
        <p className={cn(styles.description, { [classes?.descriptionClass]: classes?.descriptionClass })}>
          {description}

          {isLink ? displayedLink : displayedButton}
        </p>
      )}
    </div>
  );
};

export default AuthTitleBlock;
